import presetDictionary from './presetDictionary'
import bendRangeDictionary from './bendRangeDictionary'

export default function buildMessage(currentPreset) {
  return Object.keys(currentPreset).reduce((preset, param) => {
    if(Array.isArray(presetDictionary[param])) {
        switch (param) {
          case 'bend_range_tilt':
            // ["Keyboard_Pitch_Bend_Max", "Keyboard_Pitch_Bend_Min"]
            presetDictionary[param].forEach((p,i) => {
              preset[p] = bendRangeDictionary[i === 1 ? 'bendRangeMin' : 'bendRangeMax'][currentPreset[param]]
            })

            break;
          case 'bend_range_pad':
            // ["Keyboard_Global_USB_2_Channel", "Keyboard_Global_Key_Selection_Criteria"]
            presetDictionary[param].forEach((p,i) => {
              preset[p] = bendRangeDictionary[i === 1 ? 'bendRangeMin' : 'bendRangeMax'][currentPreset[param]]
            })

            break;
          default:

        }
    } else if(param === 'tilt_sensitivity') {
      // for some reason tilt_sensitivity is reversed
      preset[presetDictionary[param]] = 70 - currentPreset[param]
    } else {
      preset[presetDictionary[param]] = currentPreset[param]
    }

    return preset;
  }, {})
}
